<script>
  export let prev;
  export let next;
  import SwiperNavPrev from './icon/Prev.svelte';
  import SwiperNavNext from './icon/Next.svelte';
</script>

<button class="swiper-nav swiper-nav--prev" bind:this={prev}>
  <SwiperNavPrev />
</button>
<button class="swiper-nav swiper-nav--next" bind:this={next}>
  <SwiperNavNext />
</button>

<style lang="scss">
  .swiper-nav {
    padding: 0;

    cursor: default;
    position: absolute;
    z-index: 2;
    top: 50%;

    display: flex;
    align-items: center;
    justify-content: center;

    width: 5rem;
    height: 5rem;
    border-radius: 50%;

    transition: all 0.2s;

    &::before {
      content: '';
      position: absolute;
      z-index: 0;
      inset: 0;

      padding: 2px;
      border-radius: 50%;

      transition: all 0.2s;

      background: linear-gradient(
        135deg,
        #00c5e0 0%,
        #12bee9 33.33%,
        #1abbed 66.66%,
        #24fff2 100%
      );

      mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }

    :global path {
      stroke: var(--royal);

      transition: all 0.2s;
    }

    &--prev {
      left: 0;
    }

    &--next {
      right: 0;
    }

    :global &.swiper-button-disabled {
      path {
        stroke: var(--grey-2);
      }

      &::before {
        background: var(--grey-2);
      }
    }

    &:not(.swiper-button-disabled) {
      cursor: pointer;

      &:hover {
        background-color: var(--royal);

        &::before {
          opacity: 0;
        }

        :global path {
          stroke: rgb(var(--white));
        }
      }
    }

    :global &.swiper-button-lock {
      display: none;
    }

    :global .solutions-slider & {
      @include resp-max('s') {
        display: none;
      }
    }
  }
</style>
